import React from 'react';
import Footer from '../../components/Layout/Footer';
import { getAuthToken, storeUserData } from '../../components/Util';
import SubHeader from '../../components/Layout/SubHeader';
import axios from 'axios';
import api from '../../config/api';
import strings from '../../components/Language';
import { ProgressBar } from 'react-loader-spinner';
import { Link } from 'react-router-dom';
import { withRouter } from '../../config/withRouter';
import { Button, Spin } from 'antd';
import { toast } from 'react-toastify';

class NotificationScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ProgressBar: true,
            lang: strings.getLanguage(),
            access_token: null,
            errorMessage: [],
            data: [],
            next_page_url: null,
            prev_page_url: null,
            refreshing: false,
        }
    }

    async componentDidMount() {
        const self = this;
        var token = await getAuthToken();

        if (token) {
            self.setState({ access_token: token });
            await storeUserData(token, self);
            setTimeout(() => {
                self.getData();
                self.markAsReadAll();
            });
        }
    }

    getData() {
        const self = this;
        this.setState({ refreshing: true });
        axios({
            method: 'POST', url: api.InboxList + "?lang=" + this.state.lang,
            data: { lang: this.state.lang },
            headers: {
                'Authorization': 'Bearer ' + this.state.access_token,
                'Content-Type': 'application/json',
            }
        }).then(function (ress) {
            if (ress.data.error == 200) {
                self.setState({
                    data: (ress.data.data && ress.data.data.data) ? ress.data.data.data : [],
                    next_page_url: (ress.data.data && ress.data.data.next_page_url) ? ress.data.data.next_page_url : '',
                    hasMore: (ress.data.data && ress.data.data.next_page_url) ? true : false,
                    prev_page_url: (ress.data.data && ress.data.data.prev_page_url) ? ress.data.data.prev_page_url : ''
                })
            }
            self.setState({
                refreshing: false,
                ProgressBar: false
            })
        }).catch(function (erro) {
            self.setState({ ProgressBar: false });
        });
    }

    getNextPageData(APIURL) {
        const self = this;
        if(!APIURL){
            toast.error(strings['Next_link_not_found']);
            return false;
        }
        self.setState({ refreshing: true });
        axios({
            method: 'GET',
            url: APIURL,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json'
            }
        }).then(function (ress) {
            self.setState({ refreshing: false });
            if (ress.data.error == 200) {
                self.setState({
                    data: (ress.data.data && ress.data.data.data) ? [...self.state.data, ...ress.data.data.data] : self.state.data,
                    next_page_url: (ress.data.data && ress.data.data.next_page_url) ? ress.data.data.next_page_url : '',
                    hasMore: (ress.data.data && ress.data.data.next_page_url) ? true : false,
                    prev_page_url: (ress.data.data && ress.data.data.prev_page_url) ? ress.data.data.prev_page_url : ''
                })
            }
            self.setState({ ProgressBar: false });
        }).catch(function (erro) {
            self.setState({ refreshing: false });
            self.setState({ ProgressBar: false });
        });
    }

    markAsReadAll() {
        const self = this;
        axios({
            method: 'POST',
            url: api.AllReadInbox,
            data: { lang: self.state.lang },
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json',
            }
        }).then(async function (ress) {
            await storeUserData(self.state.access_token, self);
        }).catch(function (erro) {
        });
    }

    formatDate = (date) => {
        // Convert to DD/MM/YYYY
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    };

    render() {
        return (
            <>
                <ProgressBar visible={this.state.ProgressBar} height="80" width="80" color="#f05a29" borderColor='#f05a29' barColor='#f05a29' wrapperClass="progress-bar" />
                <div className="NotificationScreen">
                    <SubHeader data={{ title: strings["Announcement"] }} />

                    <main className="notification-container">
                        {this.state.data.map((item, i) =>
                            <div key={"NOTI-001-" + i} className='notification-section-row'>
                                <div className="align-content">
                                    <img src={item.documents_url} className="notification-image" alt='' />
                                </div>
                                <div className="align-content">
                                    <p dangerouslySetInnerHTML={{ __html: item.en_memo ? item.en_memo : '' }}></p>
                                </div>
                                <div className="align-content-date">
                                    <Link to={'/noficiation-view'} state={item} className='view-file'>View File</Link>
                                    <p className='date'>{this.formatDate(item.created_at)}</p>
                                </div>
                            </div>
                        )}

                        <div className='load-more'>
                            {this.state.refreshing && <Spin />}
                            {this.state.hasMore && !this.state.refreshing && (
                                <Button type="submit" id="loginButton" className="load-more-button" loading={this.state.isLoading} onClick={() => this.getNextPageData(this.state.next_page_url ? this.state.next_page_url : '')}>
                                    {strings['Load More']}
                                </Button>
                            )}
                            {(!this.state.refreshing && this.state.data && this.state.data.length <= 0) ?
                                <p>{strings["No more data to load"]}</p>
                                : null}
                        </div>

                    </main>

                    <Footer />
                </div>
            </>
        );
    }
}

export default withRouter(NotificationScreen);
